/* eslint-disable security/detect-possible-timing-attacks */
import config from './config'
import { useEffect } from 'react';
import NavigationRoutes from './routes';
import { motion } from 'framer-motion';
import { AwsRum } from 'aws-rum-web';
import Tracker from '@openreplay/tracker';
import { CookieConsent } from './CommonComponent/CookieConsent';
import AutoLogout from './components/layout/autoLogout';
import MaintenancePage from './CommonComponent/MaintenancePage';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import './App.css';

if (config.Environment.stage==="prod"){
    let awsRum = null;
    try {
        const config = {
            sessionSampleRate: 1,
            identityPoolId: "eu-west-2:531dfac8-26be-457e-83da-323858bd00e9",
            endpoint: "https://dataplane.rum.eu-west-2.amazonaws.com",
            telemetries: ["performance","errors","http"],
            allowCookies: true,
            enableXRay: false
        };

        const APPLICATION_ID = 'bf6c6c88-d8d1-4c98-9470-6eeec5589d47';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'eu-west-2';

        awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}

if (config.Environment.stage==="dev"){
    try {
        const tracker = new Tracker({
            projectKey: config.OpenReplay.projectKey,
            ingestPoint: config.OpenReplay.ingestPoint
        });

        tracker.start();
    } catch (error) {
        // Ignore errors thrown during OpenReplay tracker initialization
    }
}

function App(props) {
    const navigationPath = NavigationRoutes(props)
    const email_address= localStorage.getItem('user')
    const ldClient = useLDClient();
    const sellerShowMaintenancePage = ldClient ? ldClient.variation('SellerShowMaintenancePage', false) : false;

    /* The `useEffect` hook in this code is used to perform side effects in a functional component. In
    this case, it is used to check if there is a token parameter in the URL query string. */
    useEffect(()=>{
        const { search } = window.location;
        const params = new URLSearchParams(search);
        const token = params.get('token');
       
        if (token) {
            localStorage.setItem('verify_token', token);
            window.location = '/verify_token';
        }
        
        // Set New Relic user ID if user is already logged in
        if (email_address && window.newrelic) {
            window.newrelic.setUserId(email_address);
        }
    },[])

    if (sellerShowMaintenancePage) {
        return <MaintenancePage />;
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}>
            <AutoLogout  email_address={email_address}/> {/* Always present to monitor SBLogin flag */}
            {navigationPath}
            <CookieConsent />
        </motion.div>
    );
}

export default App;
